module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"New Product","buttons":{"cancel":"Cancel","save":"Save"},"alerts":{"success":"Product created successfully!","error":"An error occurred when creating the product!"}},"pt-BR":{"title":"Novo Produto","buttons":{"cancel":"Cancelar","save":"Salvar"},"alerts":{"success":"Produto cadastrado com sucesso!","error":"Erro ao cadastrar o produto!"}}}')
  delete Component.options._Ctor
}
